import { Component, OnInit, Input, Output, ViewEncapsulation, EventEmitter } from '@angular/core';

@Component({
    selector: 'topo-confirm',
    templateUrl: './confirm.component.html',
    styleUrls: ['./confirm.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class ConfirmComponent implements OnInit {
  @Input() isActive: boolean;
  @Input() title: string;
  @Input() message: string;
  @Input() htmlMessage: string;
  @Input() noText: string;
  @Input() yesText: string;
  @Input() icon: string;
  @Input() listItems: any;
  @Input() disableYes: boolean;
  @Input() hideNo: boolean;
  @Input() messageAlign: string = 'left';

  @Output() respond = new EventEmitter<boolean>();

  constructor() {}

  ngOnInit(): void {}

  onClose(): void {
    this.respond.emit(false);
  }

  noClick(): void {
    this.respond.emit(false);
  }

  yesClick(): void {
    this.respond.emit(true);
  }
}
